module.exports = __webpack_public_path__ + "img/xlsIcon.7246e936.png";